import React from 'react';
import TableType2 from 'src/components/sharedComponents/Tablas/TableType2/TableType2';
import { permitsList } from 'src/constants/permits';
import CardTitle from 'src/components/sharedComponents/CardTitle';

const LaunchHighPage = (props) => {
  const {
    releases, loading, permisos, onChangeState,
  } = props;

  const columns = [
    { title: 'Linea', field: 'LINEA', editable: 'never' },
    { title: 'Lanzamiento', field: 'LANZAMIENTO', editable: 'never' },
  ];

  return (
    <>
      <CardTitle title="Tabla de Lanzamientos Alta Gama" />
      <TableType2
        dataTable={releases}
        isSelection
        isEditHidden
        onSelectRow={onChangeState}
        idPermiso={permitsList.LANZAMIENTOS_ALTA_GAMA}
        minValue={permisos[permitsList.LANZAMIENTOS_ALTA_GAMA]}
        columns={columns}
        loading={loading}
        title
      />
    </>
  );
};

export default LaunchHighPage;
